import gql from 'graphql-tag'

export default config => async payload => {
  const {
    client,
    table,
    alias = 'item',
    defaultOutput,
    defaultFragments
  } = config

  const { where } = payload

  const mutation = gql`
      mutation($where: ${table}_bool_exp!) {
        ${alias}: delete_${table}(where: { _and: [$where] }) {
          affected_rows
        }
      }
    `

  const { data } = await client.mutate({
    mutation,
    variables: { where }
  })

  return data[alias]
}
